export enum QuestionnaireMasterStatus {
    ACTIVE = 0,
    DRAFT = 1,
    PUBLISHED = 2,
    TEMPLATE = 3,
    ARCHIVED = 4,
    DELETED = 5
}
